import { useContext } from "react";
import { authContext } from "./authContext";

/** @LearningJourney Authentication 9 - Returns async function that gets valid JWT (auto-refreshes if expired) */
export function useGetToken() {
  const authClient = useContext(authContext);
  if (!authClient) {
    throw new Error("AuthContext not initialised");
  }
  return authClient.client.getToken.bind(authClient.client);
}
